import { LoadingSpinner } from '../../../components/Commons';

const LoadingPage = () => {
	return (
		<div className="flex h-full w-full items-center justify-center">
			<LoadingSpinner />
		</div>
	);
};

export default LoadingPage;
